const patternMDN =
	/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export function validateEmail(email) {
	return String(email).toLowerCase().match(patternMDN);
}

export function handleHeroArrowClick() {
	const target = document.querySelector('[data-hero-scroll="true"]');
	target.scrollIntoView({ block: 'center' });
}
